var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('shared-outbound-consultation',{on:{"outboundConsultationSuccess":_vm.outboundConsultationSuccess,"saveOutboundPopup":_vm.saveOutboundPopup}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }